export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6979.c3bebc81.jpg";